export function initializeScrollTo(root) {
	const handleScrollTo = (event) => {
		const scrollLink = event.target.closest?.('[data-toggle="scroll-to"]');
		if (!scrollLink || !root.contains(scrollLink)) return;

		event.preventDefault();
		const target = root.querySelector(scrollLink.getAttribute('href'));
		target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
	};

	root.addEventListener('click', handleScrollTo);

	return () => root.removeEventListener('click', handleScrollTo);
}
